module.exports = __webpack_public_path__ + "img/logo@2x.f8ebaaf7.png";